/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetWalletInfoQueryResponse, GetWalletInfo400, GetWalletInfo401 } from "../entities/GetWalletInfo";

function getGetWalletInfoUrl() {
  const res = { method: 'GET', url: `/api/v1/account/wallet` as const }
  return res
}

/**
 * @description Получает информацию о балансе и платежных методах пользователя.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * **Процесс:**
 * 1. Получение информации о балансе из БД и платежных методах
 * 2. Возврат информации о балансе и платежных методах
 * **Пояснение по объектам:**
 * - balance:
 * - amount: Сумма баланса в копейках
 * - currency: Валюта баланса
 * - topup:
 * - presets: Массив дефолтных сумм платежа
 * - payment_methods: Массив платежных методов
 * - id: ID платежного метода
 * - title: Название платежного метода
 * - is_available: Флаг доступности платежного метода
 * - unavailable_reason: Описание недоступности платежного метода
 * - limits: Объект с минимальной и максимальной суммой платежа в копейках
 * - min: Минимальная сумма платежа
 * - max: Максимальная сумма платежа
 * @summary Получение информации о балансе и платежных методах
 * {@link /api/v1/account/wallet}
 */
export async function getWalletInfo(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetWalletInfoQueryResponse, ResponseErrorConfig<GetWalletInfo400 | GetWalletInfo401>, unknown>({ method : "GET", url : getGetWalletInfoUrl().url.toString(), ... requestConfig })
  return res.data
}